import { render, staticRenderFns } from "./DockSuggestions.vue?vue&type=template&id=aa5e3aa6&"
import script from "./DockSuggestions.vue?vue&type=script&lang=js&"
export * from "./DockSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./DockSuggestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports